module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("Preface")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('p', {
    staticClass: "FirstPara"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("This book began as a revision and updating of my "), _c('em', [_vm._v("Israel’s Law and the Church’s Faith: Paul and His Recent Interpreters")]), _vm._v("; in places it retains that character. ")]), _c('a', {
    attrs: {
      "href": "#/010_Chapter02#ch-2"
    }
  }, [_vm._v("Chapters 2")]), _vm._v(" through "), _c('span', {
    attrs: {
      "href": "#/015_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" of the earlier book are repeated, with minimal rewriting, in "), _c('span', {
    attrs: {
      "href": "#/015_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapters 6")]), _vm._v(" through "), _c('span', {
    attrs: {
      "href": "#/019_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" here. "), _c('span', {
    attrs: {
      "href": "#/016_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(" of "), _c('em', [_vm._v("Israel’s Law")]), _vm._v(", though considerably expanded, remains the basis of "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16")]), _vm._v(" in this study. Parts of "), _c('span', {
    attrs: {
      "href": "#/018_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapters 9")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/019_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" of "), _c('em', [_vm._v("Israel’s Law")]), _vm._v(" have been taken over in "), _c('span', {
    attrs: {
      "href": "#/029_Chapter19#ch-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 19")]), _vm._v(" here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#ch-1"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" of "), _c('em', [_vm._v("Israel’s Law")]), _vm._v(" was largely given to a (rather breezy) nine-page treatment of Luther, setting the stage for the summaries that followed of twentieth-century scholars who have attacked aspects of Luther’s reading of Paul. That chapter has been replaced here by a new Part One in which Luther is treated more substantially and reviewers’ suggestions that Augustine and Calvin merit a look have been adopted. Wesley has been added as well lest it be thought that all who understand Paul’s doctrine of justification to exclude any role for human “works” also championed predestination. With the additions, Part One offers a detailed and, I hope, sympathetic portrait of the “Lutheran” Paul, the object of much twentieth-century critique; one result, however, was that a book with the subtitle "), _c('em', [_vm._v("Paul and His Recent Interpreters")]), _vm._v(" needed to be renamed! Part Two of this study contains three chapters ("), _c('span', {
    attrs: {
      "href": "#/020_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" through "), _c('span', {
    attrs: {
      "href": "#/022_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(") dealing with contributions to the debate later than my work in "), _c('em', [_vm._v("Israel’s Law")]), _vm._v(". Part Three looks very different from Part Two of "), _c('em', [_vm._v("Israel’s Law")]), _vm._v(", partly because it responds to more recent literature, partly because I have attempted to refine earlier arguments, and partly because my own thinking (I would like to believe) has matured in several respects.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A quarter-century ago—around the time E. P. Sanders was completing and publishing his monumental "), _c('em', [_vm._v("Paul and Palestinian Judaism")]), _vm._v("—I pursued doctoral studies in Lund, Sweden, under the supervision of Birger Gerhardsson. "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("Gerhardsson himself is best known for his significant contributions to Matthean scholarship and to our understanding of the formation and transmission of the Gospel tradition; I should add that his sparkling chapter on Paul in "), _c('em', [_vm._v("The Ethos of the Bible")]), _vm._v(" was an important stimulus for my own thinking about the apostle. Our meetings since I returned to North America have been far too few; yet Gerhardsson’s commitment to meticulous historical scholarship, his conviction of its importance, and his continuing friendship have meant much to me over the years. To him, as a token of my appreciation and respect, this book is dedicated.")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa929560","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Preface.vue
// module id = 72
// module chunks = 0